import type { ListBuilderList } from '../../../types';

/**
 * Under Review list - licenses with no registry link AND no live match
 * candidate (no pending_review rows). Includes both never-matched licenses
 * (no client_license_match rows at all) and licenses where every candidate
 * has been rejected — both cases need a human to either confirm a manual
 * match or re-run the matchmaker.
 *
 * The list id stays `default-licenses-unmatched` to keep saved URLs and any
 * stored user state (recent lists, preferences) working — the user-facing
 * label and the underlying filter value changed only.
 */
export const unmatchedList: ListBuilderList = {
	id: 'default-licenses-unmatched',
	cacheTTL: 300000,
	name: 'Under Review',
	type: 'default',
	active: true,
	// 5 is the Bad Standing tab (PD-13949) — risk tabs sit adjacent.
	sortOrder: 6,
	filterRules: {
		licenseMatchStatus: {
			defaultValue: [{ id: 'under_review', label: 'Under Review' }],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
